<template>
  <div class="subform" :name="name" :class="[{ hidden: field.hidden }, { invalid: isSubformInvalid }]">
    <div v-if="showWithHeader" class="panel-heading">
      {{ $i18n.t(label) }}
      <span v-if="isRequired" class="required">*</span>
    </div>
    <div class="sub-form-content" :class="{ pure: !showWithHeader }" :sub-form-view-type="subformView">
      <!-- Grid -->
      <sub-form-detail-view
        v-if="isDetailView || isReadView"
        :list-head="listHead"
        :path="path"
        :read-only="readOnly"
        :isReadView="isReadView"
        @remove-row-click="onRemoveRowClick"
        :key="path"
      />
      <sub-form-collapsible-view
        v-else-if="isCollapsibleGridView"
        :list-head="listHead"
        :path="path"
        :read-only="readOnly"
        @edit-row-click="showModalEdit"
        @remove-row-click="onRemoveRowClick"
        :key="path"
      />
      <!-- List, Default, FormGrid -->
      <sub-form-grid-view
        v-else
        :list-head="listHead"
        :path="path"
        :read-only="readOnly"
        @edit-row-click="showModalEdit"
        @remove-row-click="onRemoveRowClick"
        :key="path"
      />
    </div>
  </div>
</template>

<script>
import SubFormDetailView from './SubFormDetailView.vue'
import SubFormGridView from './SubFormGridView.vue'
import SubFormCollapsibleView from './SubFormCollapsibleView.vue'
import { filter, get } from 'lodash'
import { FIELD_PROPS, FIELD_REQUIRED_LEVELS } from '../../../consts'

export default {
  name: 'SubFormViewContainer',
  components: {
    SubFormGridView,
    SubFormDetailView,
    SubFormCollapsibleView,
  },
  props: {
    listHead: {
      type: Array,
      default: () => [],
    },
    path: {
      type: String,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    isReadView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    field() {
      return this.$get('fieldByPath')(this.path) || {}
    },
    isDetailView() {
      return this.subformView === 'Grid'
    },
    isRequired() {
      const errorLevel = get(this.field, [FIELD_PROPS.VALIDATIONS, FIELD_PROPS.REQUIRED], FIELD_REQUIRED_LEVELS.NONE)
      return (
        [FIELD_REQUIRED_LEVELS.WARNING, FIELD_REQUIRED_LEVELS.ERROR].includes(errorLevel) ||
        (this.minRecCount && Number(this.minRecCount) > 0)
      )
    },
    isSubformInvalid() {
      return filter(this.$get('messages'), { name: this.name, type: 'error' }).length > 0
    },
    label() {
      return get(this.field, 'label')
    },
    minRecCount() {
      return get(this.field, 'minRecCount', 0)
    },
    name() {
      return get(this.field, 'name')
    },
    showWithHeader() {
      return !get(this.field, 'subformPure', false)
    },
    subformView() {
      return this.$get('subformView')
    },
    isCollapsibleGridView() {
      return this.subformView === 'CollapsibleGrid'
    },
  },
  methods: {
    onRemoveRowClick(rowIndex) {
      this.$emit('remove-row-click', rowIndex)
    },
    showModalEdit({ index, discardAction }) {
      this.$emit('edit-row-click', { index, discardAction })
    },
  },
}
</script>

<style scoped lang="scss">
.sub-form-content {
  overflow-x: scroll;
}
.required {
  color: $color-not-set;
}
.panel-heading {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 8px 8px 0 0;
  color: $color-text-secondary;
}
.subform.list {
  width: max-content;
}
</style>
